import { Directive, ElementRef, Renderer2 } from '@angular/core';
var NglPillImage = (function () {
    function NglPillImage(element, renderer) {
        this.element = element;
        this.renderer = renderer;
    }
    NglPillImage.prototype.ngAfterContentInit = function () {
        this.renderer.addClass(this.element.nativeElement, 'slds-pill__icon');
        this.renderer.removeClass(this.element.nativeElement, 'slds-avatar--medium');
    };
    NglPillImage.decorators = [
        { type: Directive, args: [{
                    selector: '[nglPillImage]',
                },] },
    ];
    /** @nocollapse */
    NglPillImage.ctorParameters = function () { return [
        { type: ElementRef, },
        { type: Renderer2, },
    ]; };
    return NglPillImage;
}());
export { NglPillImage };
//# sourceMappingURL=pill-image.js.map